import {createColumnHelper} from "@tanstack/react-table";

import React, {useEffect, useState} from "react";
import CardCreateNewButton from "../../components/UI/CardCreateNewButton";
import Table from "../../components/UI/Table";
import Card from "../../components/UI/Card";
import {getPermissions, getRoles} from "../../api/userRoles";
import RoleTableActions from "../../views/users/role/RoleTableActions";
import RoleForm from "../../views/users/role/RoleForm";
import {useMutation} from "@tanstack/react-query";
import {checkPermission} from "../../util/auth";
import {useNavigate} from "react-router";


const UserRole = ()=> {
    const [openModal, setOpenModal] = useState(false)
    const [role, setRoleEdit] = useState(null)
    const [permission, setPermission] = useState([])
    const columnHelper = createColumnHelper();

    const navigate = useNavigate();
    useEffect(() => {
        if(!checkPermission(['ROLE_READ'])){
            navigate("/no-access");
        }
    }, [navigate]);

    const columns = [
        columnHelper.accessor('role_name', {
            id: 'role_name',
            header: 'Name'
        }),

        columnHelper.accessor('created_at', {
            id: 'created_at',
            header: 'Create Date'
        }),

        columnHelper.display( {
            id: 'actions',
            header: "Actions",
            classes:'text_right',
            cell: props =>  <RoleTableActions editRecord={(data)=>handleEditRole(data)}  row={props.row.original} />
        }),
    ];

    const handleEditRole = (data) => {
        setRoleEdit(data)

        setOpenModal(true)
    }


    const { mutate:permissionMutate} = useMutation({
        mutationFn: getPermissions,
        onSuccess: (res) => {
            setPermission(res)
        },
    });

    useEffect(()=>{
        if(!permission.length){
            permissionMutate()
        }
    }, [permission])

    return (
        <>
            <Card title={"Roles"} CardActions={checkPermission(['ROLE_CREATE']) && <CardCreateNewButton clickHandler={()=>handleEditRole(null)} />}>
                <Table
                    queryKey={"roles"}
                    columns={columns}
                    queryParams={{per_page: 10}}
                    queryFn={getRoles}
                />
            </Card>

            {openModal &&
            <RoleForm editRecord={role}
                      permissions={permission}
                       openModal={openModal}
                       setRoleEdit={setRoleEdit}
                       setOpenModal={setOpenModal} />
            }

        </>
    )
}

export default UserRole;